import React from 'react';
import { SpreadsheetGridScrollDummyDiv } from '../../styles';

interface Props {
  rows: any[];
  headerHeight: number;
  rowHeight: number;
  refEl: any;
}

class SpreadsheetGridScrollDummy extends React.Component<Props, {}> {
  shouldComponentUpdate(nextProps: { rows: any[] }) {
    return nextProps.rows !== this.props.rows;
  }

  getHeight() {
    const { rows, rowHeight } = this.props;
    return rows.length * rowHeight + 'px';
  }

  render() {
    return (
      <SpreadsheetGridScrollDummyDiv
        className="SpreadsheetGridScrollDummy"
        style={{ height: this.getHeight() }}
        ref={this.props.refEl}
      ></SpreadsheetGridScrollDummyDiv>
    );
  }
}

export default SpreadsheetGridScrollDummy;
